/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home__Hero__Secondary_CtaInputs */

const en_home__hero__secondary_cta = /** @type {(inputs: Home__Hero__Secondary_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch how to play`)
};

/**
* | output |
* | --- |
* | "Watch how to play" |
*
* @param {Home__Hero__Secondary_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home__hero__secondary_cta = /** @type {((inputs?: Home__Hero__Secondary_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home__Hero__Secondary_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home__hero__secondary_cta(inputs)
});